import React from 'react';
import { Box, Typography, Paper, Grid } from '@mui/material';
import {
  CheckCircle as CheckCircleIcon,
  Error as ErrorIcon,
  HourglassEmpty as PendingIcon,
  Webhook as WebhookIcon,
} from '@mui/icons-material';
import type { WebhookStats } from '../../api/admin';

export function WebhookStatsCards({ stats }: { stats: WebhookStats }) {
  return (
    <Grid container spacing={2} sx={{ mb: 3 }}>
      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <Paper sx={{ p: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
            <WebhookIcon color="primary" />
            <Typography variant="body2" color="text.secondary">
              Total Events
            </Typography>
          </Box>
          <Typography variant="h5">
            {stats.totalEvents.toLocaleString()}
          </Typography>
        </Paper>
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <Paper sx={{ p: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
            <CheckCircleIcon color="success" />
            <Typography variant="body2" color="text.secondary">
              Processed
            </Typography>
          </Box>
          <Typography variant="h5" color="success.main">
            {stats.processed.toLocaleString()}
          </Typography>
        </Paper>
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <Paper sx={{ p: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
            <ErrorIcon color="error" />
            <Typography variant="body2" color="text.secondary">
              Failed
            </Typography>
          </Box>
          <Typography variant="h5" color="error.main">
            {stats.failed.toLocaleString()}
          </Typography>
        </Paper>
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <Paper sx={{ p: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
            <PendingIcon color="action" />
            <Typography variant="body2" color="text.secondary">
              Pending
            </Typography>
          </Box>
          <Typography variant="h5">
            {stats.pending.toLocaleString()}
          </Typography>
        </Paper>
      </Grid>
    </Grid>
  );
}
